<script setup lang="ts">
import { $t } from '@/composables/translations/useTranslate';
import CheckoutContentSkeleton from './CheckoutContentSkeleton.vue';
</script>

<template>
  <div class="wrapper" aria-live="polite" aria-busy="true">
    <span class="sr-only">{{ $t('ibe.common.loading', 'Loading...') }}</span>

    <div class="flex flex-col justify-center gap-10 lg:flex-row animate-pulse" aria-hidden="true">
      <!-- Left column: progress bar + step content + footer -->
      <div class="flex flex-col items-center pb-5 lg:w-2/3">
        <!-- Progress bar -->
        <div class="flex items-center justify-center w-full gap-4 mb-10">
          <template v-for="i in 3" :key="`step-${i}`">
            <div class="w-8 h-8 rounded-full bg-actions-tertiary shrink-0"></div>
            <div v-if="i < 3" class="h-1 w-12 sm:w-24 bg-actions-tertiary rounded"></div>
          </template>
        </div>

        <!-- Step content: neutral block (resolves to accordions / info box / forms) -->
        <CheckoutContentSkeleton class="w-full" />

        <!-- Footer CTA -->
        <div class="flex items-center justify-end w-full gap-5 mt-10">
          <div class="h-6 bg-actions-tertiary rounded w-24"></div>
          <div class="h-12 bg-actions-tertiary rounded w-40"></div>
        </div>
      </div>

      <!-- Right column: order summary card -->
      <div class="lg:w-1/3">
        <div class="flex flex-col lg:max-w-[435px]">
          <!-- Hotel image -->
          <div class="bg-actions-tertiary w-full h-[250px] rounded-t-[10px]"></div>

          <!-- Summary body -->
          <div class="flex flex-col gap-2.5 p-5 bg-white rounded-b-[10px]">
            <div class="h-5 bg-actions-tertiary rounded w-3/4"></div>
            <div class="h-4 bg-actions-tertiary rounded w-1/2"></div>
            <div class="h-4 bg-actions-tertiary rounded w-2/3 mb-2.5"></div>

            <!-- Check-in / out / duration -->
            <div class="flex gap-4 mb-2.5">
              <div v-for="i in 3" :key="`date-col-${i}`" class="flex-1 space-y-1.5">
                <div class="h-3 bg-actions-tertiary rounded w-full"></div>
                <div class="h-5 bg-actions-tertiary rounded w-3/4"></div>
              </div>
            </div>

            <!-- Rooms & board lines -->
            <div class="h-4 bg-actions-tertiary rounded w-1/3"></div>
            <div class="flex items-center justify-between">
              <div class="h-4 bg-actions-tertiary rounded w-1/2"></div>
              <div class="h-4 bg-actions-tertiary rounded w-16"></div>
            </div>
            <div class="flex items-center justify-between">
              <div class="h-4 bg-actions-tertiary rounded w-2/5"></div>
              <div class="h-4 bg-actions-tertiary rounded w-16"></div>
            </div>

            <!-- Total -->
            <div class="h-5 bg-actions-tertiary rounded w-1/3 ml-auto mt-2.5"></div>
            <div class="h-12 bg-actions-tertiary rounded w-full mt-2.5"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
